// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthDivider-base__wDAkf{display:flex;gap:var(--size-5);align-items:center;justify-content:space-between;width:var(--size-full);color:var(--gray-9);text-align:center;text-transform:uppercase;font:var(--font-caption-small-400);font-feature-settings:var(--feature-settings-caption-small-400);letter-spacing:var(--letter-spacing-caption-small-400)}.AuthDivider-line__lLGXX{width:var(--size-full);height:var(--size-0_25);background-color:var(--gray-a6)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "AuthDivider-base__wDAkf",
	"line": "AuthDivider-line__lLGXX"
};
export default ___CSS_LOADER_EXPORT___;
